/**
 * Das Marktregime in Worten.
 *
 * Das Backend liefert Farbe (green/yellow/red), Phase (bull/neutral/bear/
 * crash) und einen Positionsfaktor. Die Kurzform richtet sich nach der
 * Farbe -- sie ist das, was ein Anleger handeln kann.
 */
export type Ton = 'ok' | 'warn' | 'bad' | 'neutral'

export interface RegimeKern {
  label: string
  color: string
  position_size_factor: number
}

const NACH_FARBE: Record<string, { kurz: string; ton: Ton }> = {
  green: { kurz: 'Risk-On', ton: 'ok' },
  yellow: { kurz: 'Vorsicht', ton: 'warn' },
  red: { kurz: 'Risk-Off', ton: 'bad' },
}

const PHASE: Record<string, string> = {
  bull: 'Bull-Markt',
  neutral: 'Neutraler Markt',
  bear: 'Bär-Markt',
  crash: 'Crash-Risiko',
}

function empfehlung(faktor: number): string {
  if (faktor >= 1) return 'volle Positionsgrößen'
  if (faktor >= 0.7) return 'Positionen reduziert'
  if (faktor > 0) return 'nur kleine Positionen'
  return 'keine neuen Positionen'
}

export function regimeAnzeige(r: RegimeKern): { kurz: string; ton: Ton; phase: string; empfehlung: string } {
  const phase = PHASE[r.label] ?? r.label
  const farbe = NACH_FARBE[r.color] ?? { kurz: phase, ton: 'neutral' as Ton }
  return { ...farbe, phase, empfehlung: empfehlung(r.position_size_factor) }
}
